<template>
  <span id="delete-user">
    <v-btn icon color="#e8000a" @click="dialogDelete = true">
      <img src="/images/icons/delete_user.svg" alt="delete-user" style="vertical-align: middle; max-width: 26px;"/>
    </v-btn>
    <v-dialog v-model="dialogDelete" max-width="500" persistent>
      <v-card>
        <v-card-title class="tw-mt-4">
          <div class="tw-font-bold tw-text-xl">ลบบัญชีผู้ใช้งาน</div>
        </v-card-title>
        <v-card-text>
          <div class="tw-text-base">คุณต้องการลบผู้ใช้งานท่านนี้ใช่ไหม</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-progress-circular v-if="loading"
            indeterminate
            color="green"
          ></v-progress-circular>
          <v-btn color="black darken-1" text @click="dialogDelete = false" v-if="(!loading)" class="tw-tracking-normal tw-text-lg">
            <v-icon left class="tw-text-2xl">mdi-close-circle-outline</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn color="red darken-1" text @click="removeUser" v-if="(!loading)" class="tw-tracking-normal tw-text-lg">
             <img src="/images/icons/delete_user.svg" alt="delete-user-confirm" class="tw-w-6 tw-mr-1"/>
            ใช่
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: 'DeleteUser',
    props:{
      userId: String
    },
    computed: mapState({
      loading: state => state.user.loading,
    }),
    data() {
      return {
        dialogDelete: false,
      }
    },
    methods: {
      removeUser: function () {
        let companyId = this.$route.params.companyId
        this.$store.dispatch('user/removeCompanyUser', {companyId: companyId, userId: this.userId})
      },
    },
  }
</script>
<style lang="scss">
#delete-user {
  .v-application .headline {
    font-family: "Noto Sans Thai", "Noto Sans", sans-serif !important;
  }

  .icon {
    padding-right: 6px;
  }
}
</style>
